<section class="header-img-wrapper">
  <div class="container-full-img">

    <picture>
      <source media="(min-width: 992px)" srcset="/assets/img/header/lg/alexander_koenig.jpg">
      <source media="(min-width: 480px)" srcset="assets/img/header/md/about_me_alexander_koenig.jpg">
      <source media="(min-width: 0px)" srcset="assets/img/header/sm/about_me_alexander_koenig.jpg">
      <img class="img-responsive" src="/assets/img/header/lg/alexander_koenig.jpg"
           alt="Alexander Koenig">
    </picture>
  </div>
</section>
<section id="wrapper" class="container content-wrapper">
  <article class="ueber_mich">
    <div class="row">
      <div class="col-xs-12 ">
        <h1 class="headline">Willkommen bei Alexander Koenig</h1>
        <div class="blockquote-container space">
          <blockquote>Träume nicht dein Leben - lebe deinen Traum</blockquote>
        </div>

      </div>

    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <picture>
          <source media="(min-width: 992px)" srcset="/assets/img/about-me/alexander_koenig_lg.jpg">
          <source media="(min-width: 480px)" srcset="/assets/img/about-me/alexander_koenig.jpg">
          <source media="(min-width: 0px)" srcset="/assets/img/about-me/alexander_koenig.jpg">
          <img class="img-responsive" src="/assets/img/home/seebensee.jpg"
               alt="Alexander Koenig">
        </picture>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="container-about">
          <h2>Über mich</h2>
          <h3>Verschaffen Sie sich ein Bild von mir.</h3>
          <p>- Schön, dass Sie vorbei schauen. - </p>
          <ul class="list-about-me">
            <li>Mein Name ist Alexander Koenig. Ich lebe im Herzen von München und arbeite seit einigen Jahren als
              Senior Frontend Entwickler & Fotograf.
            </li>
            <li>Die Berge der Alpen (und der Welt) sind meine zweite Heimat. Sobald ich meinen Arbeitsplatz nach getaner
              Arbeit als Frontend Entwickler verlasse, findet man mich in der Natur/den Bergen um fantastische
              Momente fotografisch festzuhalten.
            </li>
            <li>Wenn ich mal nicht auf meinem Bürostuhl sitze oder in meiner zweiten Heimat unterwegs bin, treibe ich viel Sport oder unternehme viel mit meinen Freunden.</li>
            <!--<li>Falls ich mal nicht den Arbeitsplatz oder meine zweite Heimat aufsuche, mache ich viel Sport und unternehme
              viel mit meinen Freunden.
            </li>-->
          </ul>

        </div>
      </div>
    </div>
  </article>
</section>

<!--
<p>
          Hallo, ich bin Alex.</p>
        <p>Ich lebe in München und arbeite als Senior Frontend Entwickler &
          Fotograf. </p>
        <p>Mit meiner heutigen Erfahrung und Fachkompetenz habe ich mich in die Welt der Frontend Entwicklung
          spezialisiert,
          nachdem ich mir die Medienwelt genauer angeschaut habe.</p>
        <!--<p>Mit meiner Arbeit möchte ich die Onlinewelt nicht nur schöner gestalten, sondern auch nutzerfreundlicher.
            Eine gute Webseite heut zutage zu haben, ist immer wichtiger denn je.</p>--
<p>Schon während meiner Schulzeit begann meine journalistische Laufbahn als Fotograf in meiner
  Heimatstadt Amberg.</p>
<p>Nach meiner Schullaufbahn absolvierte ich eine Ausbildung als Fotomedienlaborant in Amberg und bin
  immer mehr in die Fotografie bzw. Medienwelt eingetaucht.</p>
<p>Nach meiner dreijährigen Ausbildung sammelte ich im Rahmen eines Jahrespraktikums Erfahrungen bei
  einem lokalen Fernsehsender (OTV in Amberg) um mir Einblicke in die Welt des Fernsehjournalismus zu
  schaffen.
<p>Dabei bin ich zum Entschluss gekommen, dass ich eine weitere Ausbildung als Mediengestalter Digital
  Print in München absolvieren möchte.</p>
  Print in München absolvieren möchte.</p>

-->






